<template>
<div>
    <div class="tripdatedialog-container">
        <h2>{{ $t('trips.selectDate') }}</h2>

        <DateField
            v-model="date"
            :min="minDate"
            :placeholder="$t('trips.selectDate')"
            style="margin-top: 20px; width: 100%"
        />
        <div style="display: flex; width: 100%; justify-content: space-between; gap: 10px;">
            <vs-button size="large" border block @click="callback(null, true)">
                {{ $t('common.cancel') }}
            </vs-button>
            <vs-button size="large" block @click="callback(date, true)">
                {{ $t('common.continue') }}
            </vs-button>
        </div>
    </div>

</div>
</template>

<script>
import DateField from '../elements/DateField.vue'
export default {
    name: "tripDateDialog",
    props: {
        callback: Function,
        data: Object
    },
    data(){
        return {
            date: ''
        }
    },
    computed: {
        minDate() {
            return new Date().toISOString().split('T')[0]
        }
    },
    mounted(){
        if(this.data != null && this.data.end_date){
            var d = new Date(this.data.end_date);
            if(d.getFullYear() >= 1970){
                const endDate = this.data.end_date.split('T')[0];
                const today = new Date().toISOString().split('T')[0];
                
                // Only use the end_date if it's today or in the future
                if(endDate >= today) {
                    this.date = endDate;
                }
            }
            
        }
    },
    components: { DateField }
}
</script>

<style scoped>
p,
h3,h2 {
    margin: 0;
}

.tripdatedialog-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-top: 40px;
    gap: 10px;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
}
</style>
